var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2712843430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.5 30",
    style: {
      enableBackground: "new 0 0 200.5 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 4.9505 35.507)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 18.1857 74.326)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,30H57.2V0.4h29.7V30z M58.3,28.9h27.5V1.5H58.3V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,26H60.5V4H83V26z M61.7,24.8h20.2V5.1H61.7V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.1,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 18.3112 88.963)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.3,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 75.2467 172.8755)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5,30h-29.7V0.4h29.7V30z M171.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,26h-22.5V4h22.5V26z M175.3,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 0.1702 15.984)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8769 9.6281)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,30H0V0.4h29.7V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.1H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.8,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 14.9804 75.6364)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 61.0247 148.3109)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,30h-29.7V0.4h29.7V30z M143.6,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,26h-22.5V4h22.5V26z M147,24.8h20.2V5.1H147V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.6175 62.1815)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.4,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 46.6428 123.4887)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6,30h-29.7V0.4h29.7V30z M115,28.9h27.5V1.5H115V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,26h-22.5V4h22.5V26z M118.4,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.8,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.2866 48.8549)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 32.4255 98.9269)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,30H85.5V0.4h29.7V30z M86.7,28.9h27.5V1.5H86.7V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,26H88.9V4h22.5V26z M90.1,24.8h20.2V5.1H90.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: -6.2,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 15.32 41.2278)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.0764 23.8765)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4,30H28.6V0.4h29.7V30z M29.7,28.9h27.5V1.5H29.7V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,26H32.5V4H55V26z M33.6,24.8h20.2V5.1H33.6V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,28.5c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3l1.8,4.2c0.1,0.3,0,0.6-0.3,0.7 L85,28.5z M81.9,21.1c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3l1.8,4.2 c0.1,0.3,0,0.6-0.3,0.7L81.9,21.1z M78.9,13.8c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3 l1.8,4.2c0.1,0.3,0,0.6-0.3,0.7L78.9,13.8z M75.8,6.4c-0.2,0-0.4-0.1-0.5-0.4l-1.8-4.2c-0.1-0.3,0-0.6,0.3-0.7 c0.3-0.1,0.6,0,0.7,0.3l1.8,4.2c0.1,0.3,0,0.6-0.3,0.7L75.8,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,29.6l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4 C58,29.5,57.8,29.6,57.6,29.6z M61.5,22.7l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4c0.2-0.3,0.5-0.4,0.8-0.2 c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4C61.9,22.6,61.7,22.7,61.5,22.7z M65.4,15.7l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4 c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4C65.8,15.6,65.6,15.7,65.4,15.7z M69.3,8.7l-0.3-0.1 c-0.3-0.2-0.4-0.5-0.2-0.8l2.2-4c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-2.2,4C69.7,8.6,69.5,8.7,69.3,8.7z M73.2,1.8 l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l0.4-0.6c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-0.4,0.6C73.6,1.7,73.4,1.8,73.2,1.8 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2712843430);
export default __webpack_public_path__ + "static/media/AK2_7_1284343_0.fa6158281ce53d423bcef5682e922318.svg";
export { ForwardRef as ReactComponent };